import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import $ from "jquery";
import Axios from "axios";
import DatePicker from "react-datepicker";
import JSZip from "jszip";
import moment from "moment-timezone";

import { dirname } from "../../util/resourcePath";
import { useFormatter } from "./../../util/formatter";
import { useSolarCalc } from "./../../util/calculations";
import GYAxios from "../../util/GYAxios";

import Loader from "../general/Loader";

import "react-datepicker/dist/react-datepicker.css";
import { localTimeToPickerTime, pickerTimeTolocalTime } from "../../util/momentTimezone";

function OverviewMonthlyProdtable(props) {
	window.JSZip = JSZip;
	const [formatNumber] = useFormatter();
	const [isLoading, setIsLoading] = useState(false);
	const [s_OFF, setS_OFF] = useState(0);
	const [s_ON, setS_ON] = useState(0);
	const [s_total, setS_total] = useState(0);
	const [deo_total, setDEO_total] = useState(0);
	const [consumption_total, setConsumption_total] = useState(0);
	const [siteProd, setSiteProd] = useState([]);

	const solarCalc = useSolarCalc();
	const directory = dirname();
	const [startDate, setStartDate] = useState(
		moment().subtract(1, "months").startOf("month").toDate()
	);

	const minDate = moment("2019-08-01").toDate();

	/**
	 * Fetch data based on month selected
	 * @param {Selected Month} selectedMonth
	 */
	const fetchReq = (selectedMonth, user) => {
		if (user != null) {
			// Parameters for API requests
			let column = user.type === "client" ? "client_id" : "site_id";
			let id = user.id;

			// Date formatting for API requests
			const dateFormat = "YYYYMMDD";
			const monthlyFromDate = moment(selectedMonth)
				.startOf("month")
				.format(dateFormat);
			const monthlyToDate = moment(selectedMonth)
				.endOf("month")
				.format(dateFormat);

			// COD sites Request
			const codURI = `/site/cod/moment/${monthlyToDate}/filter/${column}/${id}`;
			const reqCOD = GYAxios.get(codURI);

			// Monthly Data Request
			const reqMonthlyURI = `/monthly/filter/${column}/${id}/period/${monthlyFromDate}/${monthlyToDate}/order/dateData/DESC`;
			const reqMonthEnergy = GYAxios.get(reqMonthlyURI);

			// Make requests
			Axios.all([reqCOD, reqMonthEnergy]).then(
				Axios.spread((...responses) => {
					const resCOD = responses[0].data.error ? [] : responses[0].data;
					const resEnergy = responses[1].data.error ? [] : responses[1].data;

					let siteProdArr = [];
					let solarTotal = 0;
					let solarON = 0;
					let solarOFF = 0;
					let deo = 0;
					let consumption = 0;
					if (resCOD.length === resEnergy.length) {
						resEnergy.map((site) => {
							solarTotal += site.solar_total;
							solarON += site.solar_ON;
							solarOFF += site.solar_OFF;
							deo += site.m_DEO;
							consumption += site.m_consumption;
							const siteObj = {
								siteName: site.site_name,
								solarOnRow: formatNumber(site.solar_ON, 3),
								solarOffRow: formatNumber(site.solar_OFF, 3),
								solarRow: formatNumber(site.solar_total, 3),
								deo: formatNumber(site.m_DEO, 2),
								consumption: formatNumber(site.m_consumption, 2)
							};

							siteProdArr.push(siteObj);
						});
					} else {
						resEnergy.map((site) => {
							for (let i = 0; i < resCOD.length; i++) {
								const table_name = resCOD[i].table_name;
								if (site.table_name === table_name) {
									solarTotal += site.solar_total;
									solarON += site.solar_ON;
									solarOFF += site.solar_OFF;
									deo += site.m_DEO;
									const siteObj = {
										siteName: site.site_name,
										solarOnRow: formatNumber(site.solar_ON, 3),
										solarOffRow: formatNumber(site.solar_OFF, 3),
										solarRow: formatNumber(site.solar_total, 3),
										deo: formatNumber(site.m_DEO, 2),
										consumption: formatNumber(site.m_consumption, 2)
									};

									siteProdArr.push(siteObj);
								}
							}
						});
					}
					consumption = solarCalc.consumptionCalc(solarTotal, deo);
					setS_total(formatNumber(solarTotal, 3));
					setS_ON(formatNumber(solarON, 3));
					setS_OFF(formatNumber(solarOFF, 3));
					setDEO_total(formatNumber(deo, 2));
					setConsumption_total(formatNumber(consumption, 2))
					setSiteProd(siteProdArr);
					setIsLoading(false);
				})
			);
		}
	};

	useEffect(() => {
		if (props.client != null)
			fetchReq(moment(startDate).format("YYYY-MM-DD"), props.client);
	}, []);

	useEffect(() => {
		fetchReq(moment(startDate).format("YYYY-MM-DD"), props.client);
	}, [startDate]);

	useEffect(() => {
		// Datatables is imported in pages/_app.js
		if (siteProd != null) {
			const titles = [
				{ title: "Site Name", data: "siteName" },
				{ title: "Production On Peak (kWh)", data: "solarOnRow" },
				{ title: "Production Off Peak (kWh)", data: "solarOffRow" },
				{ title: "Total solar production (kWh)", data: "solarRow" },
				{ title: "Deemed Energy Output (kWh)", data: "deo" },
				{ title: "Consumption (%)", data: "consumption" }
			];

			const opts = {
				lengthMenu: [
					[15, 30, -1],
					[15, 30, "All"],
				],
				columns: titles,
				data: siteProd,
				columnDefs: [{ className: "table-center", targets: "_all" }],
				dom: "lfrtiBp",
				buttons: [
					{
						extend: "excelHtml5",
						text: "Download datas",
						title: "Datas",
					},
				],
				responsive: true,
				ordering: true,
				order: [0, "asc"],
				destroy: true,
			};

			$("#monthlyProd").DataTable(opts);
		}
	}, [siteProd]);

	return (
		<>
			<div
				className="perf-table panel panel-default"
				style={{ marginTop: "50px" }}
			>
				<div className="panel-heading ">
					<Row>
						<Col md="6">
							<h2 className="panel-title" id="date">
								Monthly production Overview in kWh
							</h2>
							<br />
							<div className="month-selector">
								Choose another Month: &nbsp;&nbsp;
								<DatePicker
									minDate={localTimeToPickerTime(minDate)}
									maxDate={localTimeToPickerTime(moment().subtract(1, "month").toDate())}
									selected={localTimeToPickerTime(startDate)}
									onChange={(date) => {
										setStartDate(moment(pickerTimeTolocalTime(date)).utc().toDate());
										setIsLoading(true);
									}}
									dateFormat="MMM yyyy"
									showMonthYearPicker
								/>
							</div>
						</Col>
						<Col md="6" style={{ textAlign: "right" }}>
							<img
								src={`${directory}/images/reload.png`}
								onClick={() => {
									setStartDate(moment(startDate).utc().toDate());
									setIsLoading(true);
								}}
								style={{
									height: "35px",
									cursor: "pointer",
								}}
								alt="logo"
							/>
						</Col>
					</Row>
				</div>
				<div className="panel-body">
					<table
						id="monthlyProd"
						className="table table-striped table-bordered"
						style={{ width: "100%" }}
					>
						<tfoot>
							<tr>
								<th>Total:</th>
								<th>{s_ON}</th>
								<th>{s_OFF}</th>
								<th>{s_total}</th>
								<th>{deo_total}</th>
								<th>{consumption_total}</th>
							</tr>
						</tfoot>
					</table>
				</div>
				{isLoading && (
					<Loader
						translucent={true}
						customStyle={{
							left: "40%",
							top: "45%",
							width: "20%",
							height: "30%",
						}}
					/>
				)}
			</div>
		</>
	);
}

export default OverviewMonthlyProdtable;
